import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import ServiceOccasionalActions, {
  ServiceOccasionalRedux,
  ServiceOccasionalTypes,
} from '../Redux/ServiceOccasionalRedux'
import { notificationFail, notificationSuccess } from '../Redux/NotificationActions'

import { Observable } from 'rxjs'

const ServiceOccasionalCRUDObservable = createCRUDObservable({
  mainRedux: ServiceOccasionalRedux,
  reduxPath: 'serviceOccasional',
  dataHandlers: {
    get: response => response.data,
  },
})

const postServiceOccasional = (action$, store, { Api }) =>
  action$.ofType(ServiceOccasionalTypes.postServiceOccasionalRequest).
    mergeMap(({ centerId, data }) => (
      Observable.fromPromise(Api.serviceOccasional.post(centerId, data).
        then(response => response).
        catch(error => error)).flatMap((response) => {
        const { status } = response

        if (!(status >= 200 && status < 300)) {
          return [
            ServiceOccasionalActions.postServiceOccasionalFail(response.error)]
        }

        return [
          ServiceOccasionalActions.postServiceOccasionalSuccess(),
        ]
      })
    ))

const exportServiceOccasional = (action$, store, { Api }) =>
  action$.ofType(ServiceOccasionalTypes.exportServiceOccasionalRequest)
.mergeMap(({centerId}) => (
  Observable
    .fromPromise(Api.serviceOccasional.export(centerId)
      .then(response => response)
      .catch(error => error))
    .flatMap((response) => {
      const { status } = response
      if (!(status >= 200 && status < 300)) {
        return [
          notificationFail('Falló la descarga'),
          ServiceOccasionalActions.exportServiceOccasionalFail('Falló la descarga'),
        ]
      }
      const { data } = response
      const file = response.headers['content-disposition']
      const index = file.indexOf('=')
      const fileName = file.substring(index + 1, file.length)
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName)

      document.body.appendChild(link)
      link.click()
      return [
        ServiceOccasionalActions.exportServiceOccasionalSuccess(data, fileName),
      ]
    })
))

const deleteServiceOccasional = (action$, store, { Api }) =>
  action$.ofType(ServiceOccasionalTypes.deleteServiceOccasionalRequest)
  .mergeMap(({ centerId, occasionalId }) => (
    Observable.fromPromise(Api.serviceOccasional.delete(centerId, occasionalId)
      .then((response) => response)
      .catch(error => error))
      .flatMap((response) => {
        const { status } = response
        if (!(status >= 200 && status < 300)) {
          return [
            notificationFail('Falló la eliminación'),
            ServiceOccasionalActions.deleteServiceOccasionalFail('Falló la eliminación'),
          ]
        }
        return [
          ServiceOccasionalActions.deleteServiceOccasionalSuccess(occasionalId),
          notificationSuccess('Servicio eliminado exitosamente'),
        ]
      })
  ))
export const ServiceOccasionalObservers = Object.assign({},
  ServiceOccasionalCRUDObservable.observers, {})

export const ServiceOccasionalEpic = combineEpics(
  ServiceOccasionalCRUDObservable.epic,
  postServiceOccasional,
  exportServiceOccasional,
  deleteServiceOccasional,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/ServiceOccasionalObservable.js